export default __webpack_public_path__ + "static/media/BodyPink_diffuse-min.f3ca45c6.jpg";